import { auth } from "../firebase";
import axios from "axios";
import { ethers } from "ethers";
import tokenContractJSON from "../artifacts/contracts/XIDToken.sol/XIDToken.json";

const transactionType = {
    TOKEN_TRANSFER: "tokenTransfer"
};

export class WalletService {

    static async getTokenBalancePerAddress(address: string) {
        try {
            const provider = new ethers.providers.InfuraProvider(process.env.REACT_APP_INFURA_NETWORK_NAME, process.env.REACT_APP_INFURA_API_KEY);
            const tokenAbi = tokenContractJSON.abi;
            const deployedTokenAddress = process.env.REACT_APP_DEPLOYED_TOKEN_ADDRESS;

            let tokenContract = new ethers.Contract(deployedTokenAddress!, tokenAbi, provider);
            const balance = await tokenContract.balanceOf(address);
            const formattedBalance = ethers.utils.formatEther(balance.toString());
            console.log(formattedBalance);

            return formattedBalance;
        } catch (err: any) {
            console.error(err);
            alert(err.message);
        }
    };

    static async requestTokenTransfer(targetAddress: string, tranferAmount: number) {
        try {
            const userToken = await auth?.currentUser?.getIdToken(true)
            // ToDo: Implement targetAddress and transferAmount as input fields
            const decryptAndRelayTxEndpoint = `${process.env.REACT_APP_DECRYPT_AND_RELAY_TX_URL}?idToken=${userToken}&transactionType=${transactionType.TOKEN_TRANSFER}&targetAddress=${targetAddress}&tranferAmount=${tranferAmount}`;
            const userData = await axios.get(decryptAndRelayTxEndpoint);

            return userData;
        } catch (err: any) {
            console.error(err);
            alert(err.message);
        }
    };
      
}